import { render } from "./YoutubeView.vue?vue&type=template&id=36a269e4"
import script from "./YoutubeView.vue?vue&type=script&lang=js"
export * from "./YoutubeView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__